<template>
  <div class="clients-through">
    <IQOSTable
      v-if="!selected_client"
      class="clients-table flex-full-table"
      @rowClick="c => $router.push('/clients_base/'+c._id)"
      :cols="[
        {
          title: '#',
          width: 80,
          index: true
        },
        {
          title: $t('stats.clients.name'),
          key: 'name'
        },
        {
          title: $t('stats.clients.phone'),
          key: 'phone'
        },
        {
          title: $t('stats.clients.address'),
          key: 'address'
        },
        {
          title: $t('stats.clients.averange'),
          key: 'average_check',
          currency: 'symbol',
          default: '0'
        },
        {
          title: $t('client_base.total_orders'),
          key: 'total_orders',
          default: '0'
        },
        {
          title: $t('client_base.total_visits'),
          key: 'total_visits',
          width: 80,
          default: '0'
        },
      ]"
      :rows="clients"
    >
     
    </IQOSTable>

    <ClientCardModal
      :client="selected_client"
      @close="selected_client = null"
      v-if="selected_client"
    />
  </div>
</template>

<script>

import ClientCardModal from "@/components/stats/ClientCardModal.vue";

export default {
  data() {
    return {
      search: null,
      import_modal: false,

      selected_client: null
    };
  },
  props: {
    clients: Array,
    views: Array,
    clients_map: Object,
  },
  components: {
    ClientCardModal,
  },
  methods: {
    getClientVisits(id) {
      const entry = this.views.find((v) => v._id == id);
      return entry ? entry.views_count : 0;
    },
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
    clientAddress() {
      return this.clients.some((c) => !!c.address);
    }
  },
  filters: {
    capitalize(str) {
      return str.substring(0, 1).toUpperCase() + str.substring(1);
    },
  },
};
</script>

 

 <style scoped>
 .clients-through {
   display: contents;
 }
 </style>